import { useCurrentEditor, useEditorState } from "@tiptap/react";
import type { FC } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

export const EditorButtonBlockquote: FC<EditorButtonProps> = (props) => {
  const { editor } = useCurrentEditor();
  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      isBlockquote: ctx.editor?.isActive("blockquote") || false,
      canToggleBlockquote: ctx.editor?.can().chain().toggleBlockquote().run() ?? false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <EditorButton
      {...props}
      onClick={() => editor.chain().focus().toggleBlockquote().run()}
      active={editorState.isBlockquote}
      icon="format_quote"
      tooltip="Blockquote"
      disabled={!editorState.canToggleBlockquote}
    />
  );
};
